/**
 * Types the browser renders itself, so a download link should open them in a tab
 * rather than saving them to disk.
 *
 * SVG and HTML are deliberately absent: both can carry script, and there is no
 * reason to view them in the browser rather than download them.
 */
const VIEWABLE_EXTENSIONS = new Set([
    'pdf', 'png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'ico',
    'txt', 'mp4', 'webm', 'ogg', 'mp3', 'wav',
]);

/**
 * Whether `filename` is something the browser can display.
 *
 * Shared by the admin file list and the portal so the two cannot disagree: the
 * answer also decides which kind of presigned URL the backend signs (an inline
 * URL has no Content-Disposition, so the browser saves it under the sanitised
 * S3 key instead of the original filename).
 */
export function isViewableInBrowser(filename?: string | null): boolean {
    const ext = (filename || '').split('.').pop()?.toLowerCase() ?? '';
    return VIEWABLE_EXTENSIONS.has(ext);
}
